import { Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC } from 'react';

import Checkmark from '../images/checkmark-greenV2.svg';
import Info from '../images/info-blue.svg';
import WarningOrange from '../images/warning-orange.svg';
import WarningRed from '../images/warning-red.svg';
import useStyles from './styles';

export enum InlineMessageTypes {
  blue = 'blue',
  green = 'green',
  orange = 'orange',
  red = 'red',
}

export interface InlineMessageProps {
  message: React.ReactNode;
  className?: string;
  type: `${InlineMessageTypes}`;
}

export const InlineMessage: FC<InlineMessageProps> = ({ type, message, className }) => {
  const classes = useStyles();
  let icon;

  switch (type) {
    case 'red':
      icon = WarningRed;
      break;
    case 'orange':
      icon = WarningOrange;
      break;
    case 'blue':
      icon = Info;
      break;
    case 'green':
      icon = Checkmark;
      break;
    // no default
  }

  return (
    <Grid className={classNames(classes.root, classes[type], className)} container wrap="nowrap">
      <img alt="warning icon" className={classes.icon} src={icon} />
      <Typography variant="h4">{message}</Typography>
    </Grid>
  );
};
